import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.copy.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.copy.bind(this));
  }

  copy() {
    const targetInput = document.querySelector(this.element.dataset.inputFillerTarget)
    const newValue = this.element.dataset.inputFillerValue
    if (targetInput && newValue !== undefined) {
      targetInput.value = newValue
      const form = targetInput.closest("form")
      if (form) {
        form.requestSubmit()
      }
    }
  }
}
